export default "__VITE_PUBLIC_ASSET__f39c80ef__"